import { useGetApiSchoolSettingsQuery } from 'applications/GSP/shared/api/gsp';

import type { FeatureFlags } from 'shared/components/guards/FeatureFlagGuard/types';

export const useFeatureFlag = (featureKey: FeatureFlags) => {
  const { data } = useGetApiSchoolSettingsQuery();

  return data?.charts?.[featureKey] ?? false;
};
